import { RefObject, useEffect, useState } from "react";

export const useStackedBarWidth = (
    isLoading: boolean = false,
    numberOfBarGroups: number,
    refToAdjust: RefObject<HTMLDivElement>,
): {
    totalWidth: number;
    barGroupWidth: number;
} => {
    const [totalWidth, setTotalWidth] = useState<number>(0);

    useEffect(() => {
        const handleResize = () => {
            setTotalWidth(refToAdjust.current?.offsetWidth ?? 0);
        };

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [refToAdjust.current, isLoading]);

    const calculatedBarGroupWidth = (0.5 * totalWidth!) / numberOfBarGroups - 5;
    return {
        totalWidth,
        barGroupWidth: calculatedBarGroupWidth >= 0 ? calculatedBarGroupWidth : 0,
    };
};
